export default [
    {
        path: "/tokerDetail",
        name: "TokerDetail",
        component: () => import("@/views/Toker/detail"),
    },
];
